import { render, staticRenderFns } from "./headerChartBars.vue?vue&type=template&id=585c69f0&"
import script from "./headerChartBars.vue?vue&type=script&lang=js&"
export * from "./headerChartBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports